import React from 'react';
import { FeatureLeaderboard } from '@models/feature-leaderboard';

import {
  FeatureStatisticsTable,
  FeatureDistributionChart,
  FeatureCorrelatedFeaturesTable,
} from '../../../feature/feature-details';

export const FeatureLeaderboardEntryDetails: React.FC<{
  entry: FeatureLeaderboard.Entry;
}> = ({ entry }) => {
  return (
    <div>
      <div style={{ display: 'flex', gap: '50px' }}>
        <div className="feature-metrics" style={{ flex: 3 }}>
          <h3 className="grey-label">Feature Statistics:</h3>
          <FeatureStatisticsTable statistics={entry.stats} />
        </div>
        <div className="feature-histogram" style={{ flex: 1 }}>
          <h3 className="grey-label">Feature Distribution:</h3>
          <FeatureDistributionChart histogram={entry.histogram} />
        </div>
      </div>
      <div className="correlated-features">
        <h3 className="grey-label">Correlated Features:</h3>
        <FeatureCorrelatedFeaturesTable
          correlatedFeatures={entry.topCorrelatedFeatures}
        />
      </div>
    </div>
  );
};
